import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import type { RELATIONSHIP_STATUS } from 'hb-react/shared/apps/Mentoring/constants';

interface StatusIconProps {
  status?: keyof typeof RELATIONSHIP_STATUS;
}

const StatusIcon = ({ status }: StatusIconProps) => {
  switch (status) {
    case 'accepted':
      return (
        <Wrapper>
          <FontAwesomeIcon
            iconName="circle-check"
            height="20px"
            color="grass"
            iconType={CATEGORIES.SOLID}
          />
        </Wrapper>
      );
    case 'pending':
      return (
        <Wrapper>
          <FontAwesomeIcon
            iconName="clock"
            height="20px"
            color="mandarine"
            iconType={CATEGORIES.SOLID}
          />
        </Wrapper>
      );
    default:
      return null;
  }
};

export default StatusIcon;

const Wrapper = styled(Box).attrs({ display: 'block', bg: 'white' })`
  position: absolute;
  top: 40px;
  right: -2px;
  border-radius: 50%;
`;
